import { render, staticRenderFns } from "./Offices.html?vue&type=template&id=480a525c&"
import script from "./Offices.js?vue&type=script&lang=js&"
export * from "./Offices.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports